const prefix = "/movies";

export const apiEndpoint =
  //"https://littlerideruat.azurewebsites.net/LittleAppAPI.aspx";
  !process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ? "http://localhost:5000/api/"
    : prefix + "/api/";

export const emailEndpoint =
  //"https://littletasks.azurewebsites.net/api/LittleTasks";
  !process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ? "http://localhost:5000/send-receipt"
    : prefix + "/send-receipt";

export const generateReceiptEndpoint =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ? "http://localhost:5000/generate-receipt"
    : prefix + "/generate-receipt";

export const payEndpoint =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ? "http://localhost:5000/pay"
    : prefix + "/pay";

export const checkPayEndpoint =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ? "http://localhost:5000/pay/retry"
    : prefix + "/pay/retry";

export const authEndpoint =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ? "http://localhost:5000/auth"
    : prefix + "/auth";

export const receiptEndpoint =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development"
    ? "http://localhost:5000/receipt/viewReceipt"
    : prefix + "/receipt/viewReceipt";

export const testMobileNumber = "254700928129";
